module.exports = require("key-encoder");